<template>
  <div class="goal-scale">
    <div class="title">
      Health Assessment Goals
    </div>

    <div
      v-if="['Renal Diabetes'].includes(food_spiral)"
      class="section orange"
    >
      <div class="color">
        <div class="circle" />
      </div>
      <div class="data">
        <div class="top">
          <div class="side current">
            <div class="title">
              Weight: {{ formatter.format(weight_current) }}
            </div>
            <div class="subtitle">
              Starting Weight: {{ formatter.format(weight_starting) }}
            </div>
          </div>
          <div class="side goal">
            <div class="subtitle">
              Goal: {{ formatter.format(weight_goal) }}
            </div>
            <div class="subtitle">
              Weeks: {{ weight_weeks }}
            </div>
          </div>
        </div>
        <div class="progress-bar">
          <div
            class="bar"
            :style="{width: ((weight_starting - weight_current) / (weight_starting - weight_goal) * 100) + '%'}"
          />
        </div>
        <div
          v-if="weight_delta > 0"
          class="subtitle"
        >
          Last Change: {{ formatter.format(weight_delta) }}
        </div>
      </div>
    </div>

    <div class="section blue">
      <div class="color">
        <div class="circle" />
      </div>
      <div class="data">
        <div class="top">
          <div class="side current">
            <div class="title">
              Steps: {{ formatter.format(steps_current) }}
            </div>
          </div>
          <div class="side goal">
            <div class="subtitle">
              Goal: {{ formatter.format(steps_goal) }}
            </div>
          </div>
        </div>
        <div class="progress-bar">
          <div
            class="bar"
            :style="{width: (steps_current / steps_goal * 100) + '%'}"
          />
        </div>
        <div class="subtitle">
          Difference: {{ formatter.format(Math.max(0, steps_goal - steps_current)) }}
        </div>
      </div>
    </div>

    <div
      v-if="fluids_cups_current!=null && fluids_cups_goal!=null"
      class="section green"
    >
      <div class="color">
        <div class="circle" />
      </div>
      <div class="data">
        <div class="top">
          <div class="side current">
            <div class="title">
              Fluids: {{ formatter.format(fluids_cups_current) }} cups
              <i
                v-if="typeof(goaldata) != 'undefined' && goaldata.fluids"
                v-tooltip:top="fluid_current_tooltip"
                class="text-primary fa fa-info-circle"
                data-html="true"
              />
            </div>
          </div>
          <div class="side goal">
            <div class="subtitle">
              Goal: {{ formatter.format(fluids_cups_goal) }} cups
            </div>
          </div>
        </div>
        <div class="progress-bar">
          <div
            class="bar"
            :style="{width: (fluids_cups_current / fluids_cups_goal * 100) + '%'}"
          />
        </div>
        <div class="subtitle">
          Difference: {{ formatter.format(fluids_cups_goal - fluids_cups_current) }} cups
        </div>
      </div>
    </div>

    <div class="section red">
      <div class="color">
        <div class="circle" />
      </div>
      <div class="data">
        <div class="top">
          <div class="side current">
            <div class="title">
              Sleep: {{ formatter.format(sleep_current) }}
            </div>
          </div>
          <div class="side goal">
            <div class="subtitle">
              Goal: {{ formatter.format(sleep_goal) }}
            </div>
          </div>
        </div>
        <div class="progress-bar">
          <div
            class="bar"
            :style="{width: (sleep_current / sleep_goal * 100) + '%'}"
          />
        </div>
        <div class="subtitle">
          Days a week you get <strong>6 to 8 hours</strong> of sleep a night.
        </div>
      </div>
    </div>

    <div
      v-if="['Renal Diabetes'].includes(food_spiral)"
      class="section purple"
    >
      <div class="color">
        <div class="circle" />
      </div>
      <div class="data">
        <div class="top">
          <div class="side current">
            <div class="title">
              Calories: {{ formatter.format(calories_current) }}
            </div>
          </div>
          <div class="side goal">
            <div class="subtitle">
              Calories Needed: {{ formatter.format(calories_goal) }}
            </div>
          </div>
        </div>
        <div class="progress-bar">
          <div
            class="bar"
            :style="{width: (calories_current / calories_goal * 100) + '%'}"
          />
        </div>
        <div class="subtitle">
          Difference: {{ formatter.format(calories_goal - calories_current) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    goaldata: Object
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('en-US'),
      // Pull this from API
      food_spiral: '...',
      weight_starting: 0,
      weight_current: 0,
      weight_goal: 110,
      weight_weeks: '0/10',
      weight_delta: 2,
      steps_current: 0,
      steps_goal: 6000,
      fluids_cc_current: null,
      fluids_cc_goal: null,
      sleep_current: 0,
      sleep_goal: 7,
      calories_current: 0,
      calories_goal: 1140,
    }
  },
  computed: {
    fluids_cups_current: function () {
      return parseFloat(this.fluids_cc_current / 236.6).toFixed(2);
    },
    fluids_cups_goal: function () {
      return parseFloat(this.fluids_cc_goal / 236.6).toFixed(2);
    },
  },
  watch: {
    'goaldata': function () {
      this.load_profile();
      this.load_goals()
    }
  },
  methods: {
    async load_goals() {
      if (typeof (this.goaldata) != 'undefined') {

        this.weight_starting = this.goaldata.weight.start_weight;
        this.weight_current = this.goaldata.weight.weight;
        this.weight_goal = this.goaldata.weight.goal;
        this.weight_weeks = this.goaldata.weight.goal_weight_weeks;
        this.weight_delta = this.goaldata.weight.goalt_weight_change;

        this.steps_current = this.goaldata.exercise.steps_current;
        this.steps_goal = this.goaldata.exercise.steps_goals;

        if (this.goaldata.fluids) {
          this.fluids_cc_current = this.goaldata.fluids.current;
          this.fluids_cc_goal = this.goaldata.fluids.goal;
        }
        //fluids only exist for renal spirals

        this.sleep_current = this.goaldata.sleep.days_6_to_8;

        this.calories_current = this.goaldata.calories.current;
        this.calories_goal = this.goaldata.calories.goal;

      }

    },
    async load_profile(){
      // Profile
      let get_profile = await this.$http('/api/share-portal/profile', {
        method: 'GET',
      })
        .then(response => response.json())
        .then(async function(json) {
          return json;
        });

      if(get_profile.message == "Invalid."){
        this.isvalid=false;
        return false;
      }
      let fetch_profile = get_profile.data;
      if (typeof(fetch_profile) != 'undefined') {
        this.food_spiral = fetch_profile.spiral_name;
      }

    },
    fluid_current_tooltip() {
      return `${this.fluids_cups_current} of ${this.fluids_cups_goal} cups <br/>`
          + `${parseFloat(this.fluids_cc_current / 29.574).toFixed(2)} of ${parseFloat(this.fluids_cc_goal / 29.574).toFixed(2)} ounces <br/> `
          + `${parseFloat(this.fluids_cc_current).toFixed(2)} of ${parseFloat(this.fluids_cc_goal).toFixed(2)} cc`;
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
